import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/soundTitle/importer/soundTitleImporterActions';

export default importerReducers(actions);
